/**
 * Хелпер который помечает текст для екстракта в переводы.
 * Используется как маркер для ngx-translate-extract.
 * Ошибка описана в этом issue: https://github.com/biesbjerg/ngx-translate-extract/issues/55
 * @param {string} string Строка, которую нужно перевести
 * @returns {string}
 */
export function ngxTranslateExtract (string: string) {
  return string;
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/translates/ngx-translate-extract.ts